import React, { useContext, useEffect, useState } from 'react';
import EscoDataGrid from '../../Controls/EscoGrid/EscoDataGrid';

import { getImageList, frmDelFirma, frmDelImg } from '../../../Service/imagen'
import ImagenView from './ImagenView';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography } from '@mui/material';
import { AuthContext } from '../../../Context/AuthContext';

function ImagenDataView(props) {

    const [imagenes, setImagenes] = useState([]);
    const [loading, setLoading] = useState(false);
    const { accessToken } = useContext(AuthContext);
    const { getAccessToken } = useContext(AuthContext);

    const [rowSelectd, setRowSelectd] = useState("Hola");


    //region - "description"

    /*DELETE INICIO*/
    const [showDelete, setShowDelete] = useState(false)

    const closeDeleteDialog = () => {
        setShowDelete(false);
    };

    const ConfirmDelete = () => {
        delFondoImg(rowSelectd);
        setShowDelete(false);
    }

    const delFondoImg = (row) => {

        if (row.Tipo == "L") {

            var frmDelImgRequest = {
                stream_id: row.stream_id
            }

            const datos = { frmDelImgRequest }

            frmDelImg(datos, accessToken)
                .then(data => {

                    if (data != undefined && data.Message != undefined && data.Message.includes("Error")) {

                        init();
                        return;
                    } else {
                        init();
                    }
                }).catch(
                    error => {

                    });

        } else if (row.Tipo == "F") {

            var frmDelFirmaRequest = {
                stream_id: row.stream_id
            }

            const datos = { frmDelFirmaRequest }

            frmDelFirma(datos, accessToken)
                .then(data => {

                    if (data != undefined && data.Message != undefined && data.Message.includes("Error")) {

                        init();
                        return;
                    } else {
                        init();
                    }
                }).catch(
                    error => {

                    });
        }

    }

    //endregion

    const init = () => {
        setLoading(true);

        //const token = getAccessToken()

        getAccessToken()
            .then((token) => {
                getImageList(token)
                    .then((data) => {
                        setImagenes(data);
                        setLoading(false)
                    })
                    .catch()
                    .finally(() => setLoading(false))

            })
    }

    useEffect(() => {
        init();

    }, [getAccessToken])

    const columns = [
        { field: 'Descripcion', headerName: 'Descripción', width: 300, editable: false },
        { field: 'Tipo', headerName: 'Tipo', width: 100, valueGetter: (params) => { return params.row.Tipo === 'L' ? 'Logo' : 'Firma' } },
        { field: 'es_default', headerName: 'Default', width: 100, valueGetter: (params) => { return params.row.es_default === 0 ? 'No' : 'Si' } },

        /*         {
                    field: 'imagen', headerName: 'Imagen', width: 160, editable: false, renderCell: (params) => {
                        if (params.value) {
                            const imagen1 = URL.createObjectURL(params.value);
        
                            return <img className='thumb' src={imagen1} alt='thumb' />
                        };
                    }
                }, */

    ];

    let rows = imagenes;

    function setData(data) {
        setImagenes(imagenes.concat({ stream_id: data.stream_id, Descripcion: data.Descripcion, Tipo: data.Tipo }))
    }

    function getRowId(row) {
        return row.stream_id
    }

    return (
        <Box sx={{ height: 600, width: '100%' }}>

            <Typography variant="button" sx={{ fontSize: 14, color: 'gray' }}>Configuración de Formularios: Imágenes</Typography>
            <EscoDataGrid
                rows={rows}
                columns={columns}
                loading={loading}
                getRowId={getRowId}
                pEliminar={true}
                pEditar={false}
                pSetShowDelete={setShowDelete}
                pSetRowSelectd={setRowSelectd}>
                <ImagenView setData={setData} pInit={init} />
            </EscoDataGrid>
            <Dialog open={showDelete} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">
                    {"Atención"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        ¿Desea eliminar el registro?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeDeleteDialog}>Cancelar</Button>
                    <Button onClick={ConfirmDelete} autoFocus>
                        Aceptar
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
}

export default ImagenDataView;